import script from "./goRinSyo0034.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0034.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0034.vue?vue&type=style&index=0&id=3540267b&lang=scss"

const __exports__ = script;

export default __exports__